import {
  EXCEL_LIST,
  AUTH_STAFF_SEL,
  AUTH_STAFF_ADD,
  AUTH_STAFF_MOD,
  AUTH_STAFF_DET,
  AUTH_STAFF_DEL,
  ROOT_MODAL_VIEW
} from 'actions/etc';

function etc(state = {}, action) {
  const { payload } = action;

  switch (action.type) {
    case `${EXCEL_LIST}_PENDING`:
      return {
        ...state,
        list: payload
      };
    case `${EXCEL_LIST}_FULFILLED`:
      return {
        ...state,
        list: payload
      };
    case `${EXCEL_LIST}_REJECTED`:
      return {
        ...state,
        list: payload
      };
    case `${AUTH_STAFF_SEL}_FULFILLED`:
      return {
        ...state,
        authStaffList: payload
      };

    case `${AUTH_STAFF_SEL}_PENDING`:
      return {
        ...state,
        authStaffList: payload
      };

    case `${AUTH_STAFF_SEL}_REJECTED`:
      return {
        ...state,
        authStaffList: payload
      };
    case `${AUTH_STAFF_ADD}_FULFILLED`:
      return {
        ...state,
        authStaffAdd: payload
      };

    case `${AUTH_STAFF_ADD}_PENDING`:
      return {
        ...state,
        authStaffAdd: payload
      };

    case `${AUTH_STAFF_ADD}_REJECTED`:
      return {
        ...state,
        authStaffAdd: payload
      };

    case `${AUTH_STAFF_MOD}_FULFILLED`:
      return {
        ...state,
        authStaffMod: payload
      };

    case `${AUTH_STAFF_MOD}_PENDING`:
      return {
        ...state,
        authStaffMod: payload
      };

    case `${AUTH_STAFF_MOD}_REJECTED`:
      return {
        ...state,
        authStaffMod: payload
      };
    case `${AUTH_STAFF_DET}_FULFILLED`:
      return {
        ...state,
        authStaffDet: payload
      };

    case `${AUTH_STAFF_DET}_PENDING`:
      return {
        ...state,
        authStaffDet: payload
      };

    case `${AUTH_STAFF_DET}_REJECTED`:
      return {
        ...state,
        authStaffDet: payload
      };
    case `${AUTH_STAFF_DEL}_FULFILLED`:
      return {
        ...state,
        authStaffDel: payload
      };

    case `${AUTH_STAFF_DEL}_PENDING`:
      return {
        ...state,
        authStaffDel: payload
      };

    case `${AUTH_STAFF_DEL}_REJECTED`:
      return {
        ...state,
        authStaffDel: payload
      };

    case ROOT_MODAL_VIEW:
      return {
        ...state,
        modal: action.modal
      };

    default:
      return state;
  }
}

export default etc;
